module.exports = __webpack_public_path__ + "img/anteraja.d1f88466.png";